/**
 * IAM 服务 API 封装层
 *
 * 封装所有与用户认证、用户信息相关的 API 调用
 * @/app/hooks 必须通过此层调用,不能直接引用 @/app/services/iam
 */

import {
  appsGet,
  appsResetToken,
  usersDelete,
  usersGetMe,
  usersGetUserEveryDayCredit,
  usersGetUserTrialExpiration,
  usersListMyTeamMembers,
  usersListSpaces,
  usersLoginWithThirdParty,
  usersSubmitQuestionnaire,
  usersSwitchSelf,
  usersSwitchSpace,
  usersUpdateProfile,
} from '@/app/services/iam';

/**
 * 获取当前用户信息
 */
export const getCurrentUser = usersGetMe;

export { usersDelete, usersUpdateProfile };

/**
 * 获取用户每日积分
 */
export const getUserEveryDayCredit = usersGetUserEveryDayCredit;

/**
 * 获取用户试用到期信息
 */
export const getUserTrialExpiration = usersGetUserTrialExpiration;

/**
 * 获取当前用户可访问的空间列表
 */
export const getUserSpaces = usersListSpaces;

/**
 * 切换当前访问空间
 */
export const switchUserSpace = (spaceId: string | 'self') => {
  if (spaceId === 'self') {
    return usersSwitchSelf();
  }
  return usersSwitchSpace({
    body: {
      space_id: spaceId,
    },
  });
};

/**
 * 获取当前团队成员列表
 */
export const getMyTeamMembers = usersListMyTeamMembers;

/**
 * 使用第三方授权结果登录
 */
export const loginWithThirdParty = usersLoginWithThirdParty;

/**
 * 提交问卷
 */
export const submitQuestionnaire = usersSubmitQuestionnaire;

/**
 * 获取应用 token（Vidu Token）
 */
export const getAppToken = appsGet;

/**
 * 重置应用 token（Vidu Token）
 */
export const resetAppToken = appsResetToken;
